/**
 * Shared bloc membership for the smart-text totals and the "2026 v. 2022"
 * seat-comparison chart — the ONE file to edit to add/remove a party from a
 * bloc, or change a seat threshold. `calculateSmartVars` (src/lib/utils) and
 * `ElectionComparison` both import from here rather than hardcoding their own
 * party lists, so the two stay in sync.
 *
 * Keys match `crosswalk.ts`'s `parties[].key`.
 */

/**
 * A party polling at or below this many seats is dropped entirely from the
 * 2026 estimate — no bar segment on the chart, and not counted toward any
 * bloc total in the smart text. Override per-party via `BlocMember.minSeats`.
 */
export const minSeatsToShow = 3;

export interface BlocMember {
  key: string;
  /** Overrides `minSeatsToShow` for this party's bloc-total contribution only. */
  minSeats?: number;
}

/** Likud-led, pro-Netanyahu bloc. */
export const governingCoalition: BlocMember[] = [
  { key: 'likud' },
  { key: 'religious_zionism_identity' },
  { key: 'jewish_power' },
  { key: 'shas' },
  { key: 'united_torah_judaism' },
];

/** Curated anti-Netanyahu alliance — not every opposition-leaning party. */
export const antiNetanyahuBloc: BlocMember[] = [
  { key: 'yashar' },
  { key: 'together' },
  { key: 'democrats' },
  { key: 'israel_our_home' },
  { key: 'joint_list' },
  { key: 'raam' },
];
